import React from "react";
import {RouteObject} from "react-router-dom";
import ServiceRfqQuoteLayout from "../../layout/ServiceRfqQuoteLayout/ServiceRfqQuoteLayout";

const ServiceRfqQuoteRoutes : RouteObject[] = [
    {
        path:'servicerfq',
        element:<ServiceRfqQuoteLayout/>
    }
]
export default ServiceRfqQuoteRoutes;